export default __webpack_public_path__ + "static/media/gcpd.8381d3e4.png";